import { Type } from "@angular/core";
import { FirestoreUser, Person, GameRecord, IContextSetting, IContextModule, HuntingEvent, HuntingDistrict, ConfigurationItem, LaboratorySample, GameCollectStation, PointOfInterest, Trophy, SiteReferralItem, GeoObjLineTypesData, GeoObjPolygonTypesData, FirestoreInviteUser, GeoObjCategoryData, usRolesDataAccess, userRolesData } from "diwimamodelweb/lib";
import { from } from "rxjs";
import { FilterListComponent } from "../filter-list/filter-list.component";
import { GameCollectStationFormComponent } from "../game-collect-station-form/game-collect-station-form.component";
import { GamerecordFormBaseComponent } from "../gamerecord-form-base/gamerecord-form-base.component";
import { GamerecordFormHandlerComponent } from "../gamerecord-form-handler/gamerecord-form-handler.component";
import { GamerecordFormSpeciesComponent } from "../gamerecord-form-species/gamerecord-form-species.component";
import { GamerecordFormUtilizationComponent } from "../gamerecord-form-utilization/gamerecord-form-utilization.component";
import { HuntingDistrictFormComponent } from "../hunting-district-form/hunting-district-form.component";
import { HuntingEventFormComponent } from "../hunting-event-form/hunting-event-form.component";
import { LabSampleFormComponent } from "../lab-sample-form/lab-sample-form.component";
import { LocationPickerComponent } from "../location-picker/location-picker.component";
import { PersonFormComponent } from "../person-form/person-form.component";
import { PoiFormHandlerComponent } from "../poi-form-handler/poi-form-handler.component";
import { PoiFormComponent } from "../poi-form/poi-form.component";
import { SettingFormBaseComponent } from "../setting-form-base/setting-form-base.component";
import { SettingGeoObjectTypeFormComponent } from "../setting-geo-object-type-form/setting-geo-object-type-form.component";
import { SettingSiteReferralComponent } from "../setting-site-referral/setting-site-referral.component";
import { TrophyFormComponent } from "../trophy-form/trophy-form.component";
import { UserFormComponent } from "../user-form/user-form.component";
import { GeoObjectLineTypesSettingFormComponent } from "../geo-object-line-types-setting-form/geo-object-line-types-setting-form.component";
import { GeoObjectPolygonTypesSettingFormComponent } from "../geo-object-polygon-types-setting-form/geo-object-polygon-types-setting-form.component";
import { InviteUserFormComponent } from "../invite-user-form/invite-user-form.component";
import { GeoObjectCategoryFormComponent } from "../geo-object-category-form/geo-object-category-form.component";
import { GamerecordFormLabSamplesComponent } from "../gamerecord-form-lab-samples/gamerecord-form-lab-samples.component";
import { UserRolesFormComponent } from "../user-roles-form/user-roles-form.component";


export abstract class Form {

    abstract className: string

    listeners: Set<any> = new Set()
    addListener(obj: any) {
        this.listeners.add(obj)
    }

    removeListener(obj: any) {
        this.listeners.delete(obj)
    }
    abstract componentRef: Type<any>|undefined
    constructor(
        public name: string,
        public data?: any
    ) {}

    abstract onCancle()
    abstract onSuccessfullySubmitted()

    onNavBack: Function|undefined
}

export interface FormListener {
    onCancle: ((item: Form) => void)|undefined
    onSuccessfullySubmitted: ((item: Form) => void)|undefined 
}

export class PersonForm extends Form {

    public static className = "PersonForm"
    public className = "PersonForm"

    componentRef = PersonFormComponent

    constructor(
        name: string, 
        data?: Person
    ) {
        super(name, data)
    }

    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }
    onDelete(){
        this.listeners.delete(this);
    }
}

export class UserForm extends Form {

    public static className = "UserForm"
    public className = "UserForm"

    componentRef = UserFormComponent

    constructor(
        name: string, 
        data?: FirestoreUser
    ) {
        super(name, data)
    }

    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }
    onDelete(){
        this.listeners.delete(this);
    }
}

export class InviteUserForm extends Form {

    public static className = "InviteUserForm"
    public className = "InviteUserForm"

    componentRef = InviteUserFormComponent

    constructor(
        name: string, 
        data?: FirestoreInviteUser
    ) {
        super(name, data)
    }

    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

}

export class 



GameRecordForm extends Form {

    public static className = "GameRecordForm"
    public className = "GameRecordForm"

    componentRef = GamerecordFormHandlerComponent
    subFormRefs = new Map<string, Type<any>>([
        [GameRecordSubForms.BASE, GamerecordFormBaseComponent],
        [GameRecordSubForms.SPECIES, GamerecordFormSpeciesComponent],
        [GameRecordSubForms.LABSAMPLES, GamerecordFormLabSamplesComponent],
        [GameRecordSubForms.ERLEGER, FilterListComponent],
        [GameRecordSubForms.DISTRICTS, FilterListComponent],
        [GameRecordSubForms.EVENTS, FilterListComponent],
        [GameRecordSubForms.UTILIZATION_OPTION, GamerecordFormUtilizationComponent],
        [GameRecordSubForms.PLACEOFKILLING, LocationPickerComponent],
        [GameRecordSubForms.HUNTERLOCATION, LocationPickerComponent],

        // ... etc
    ])

    constructor(
        name: string, 
        public constextSettings: Map<string, IContextSetting|undefined>,
        public constextModules: Map<string, IContextModule|undefined>,
        public person: Person[],
        public geoObjects: any[],
        public huntingDistricts: HuntingDistrict[],
        public events: HuntingEvent[],
        public data?: GameRecord,
    ) {
        super(name, data)
    }

    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onSubmit: (() => void)|undefined = undefined

    onDelete(){
        this.listeners.forEach((obj: any) => {
            obj.onDelete(this)
        })
    }
}

export class HuntingEventForm extends Form {

    public static className = "HuntingEventForm"
    public className = "HuntingEventForm"

    componentRef: Type<any> = HuntingEventFormComponent;    
    constructor(
        public name: string,
        public huntingDistricts: HuntingDistrict[],
        public data?: HuntingEvent
    ) {
        super(name, data)
    }

    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }
}

export enum GameRecordSubForms {
    BASE = 'base', SPECIES = 'species',
    ERLEGER = "erleger", DISTRICTS = "districts",
    EVENTS = "events", UTILIZATION_OPTION = "uitilization",
    PLACEOFKILLING = "placeOfKilling", HUNTERLOCATION = "hunterLocation", LABSAMPLES="laboratorySamples"
}

export class BaseSettingForm extends Form {

    public static className = "BaseSettingForm"
    public className = "BaseSettingForm"
    
    public componentRef: Type<any> = SettingFormBaseComponent
    // no sub forms... 

    constructor(
        public name: string,
        public settingId: string,
        public data?: ConfigurationItem,
        public person?: Person[]
    ) {
        super(name, data)
    }
    
    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onSubmit: (() => void)|undefined = undefined
    onCreate: ((data: any) => void)|undefined = undefined
    onDelete: ((data: any) => void)|undefined = undefined
}

export class LaboratorySampleForm extends Form {

    public static className = "LaboratorySampleForm"
    public className = "LaboratorySampleForm"

    componentRef: Type<any> = LabSampleFormComponent
    
    constructor(
        name: string,
        public contextSettings: Map<string, IContextSetting>,
        data?: LaboratorySample
    ) {
        super(name , data)
    }

    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onDelete(){
        this.listeners.forEach((obj:any) => {
            obj.onDelete(this)
        })
    }

}

export class HuntingDistrictForm extends Form {

    public static className = "HuntingDistrictForm"
    public className = "HuntingDistrictForm"

    componentRef: Type<any> = HuntingDistrictFormComponent
    
    constructor(
        name: string,
        // outline?? 
        data?: HuntingDistrict
    ) {
        super(name , data)
    }

    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onDelete(){
        this.listeners.delete(this);
    }

}

export class GameCollectStationForm extends Form {

    public static className = "GameCollectStationForm"
    public className = "GameCollectStationForm"

    componentRef: Type<any> = GameCollectStationFormComponent
    
    constructor(
        name: string,
        // outline?? 
        public huntingDistricts: HuntingDistrict[],
        data?: GameCollectStation
    ) {
        super(name , data)
    }

    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onDelete(){
        this.listeners.delete(this);
    }
}

export enum PoiSubForm {
    BASE = "base",
    LOCATION = "locationCoordinates"
}

export interface PoiMapEditorData {
    data:PointOfInterestForm
    form:any
    type:string
    identifier:string
}

export class PointOfInterestForm extends Form {

    public static className = "PointOfInterestForm"
    public className = "PointOfInterestForm"

    componentRef = PoiFormHandlerComponent
    subFormRefs = new Map<string, Type<any>>([
        [PoiSubForm.BASE, PoiFormComponent],
        [PoiSubForm.LOCATION, LocationPickerComponent]
    ])

    constructor(
        name: string,
        public constextSettings: Map<string, IContextSetting|undefined>,
        public huntingDistricts: HuntingDistrict[],
        data?: PointOfInterest
    ) {
        super(name, data)
    }

    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onSubmit: (() => void)|undefined = undefined
    onDelete(){
        this.listeners.forEach((obj: any) => {
            obj.onDelete(this)
        })
    }

    

}

export class TrophyForm extends Form {

    public static className = "TrophyForm"
    public className = "TrophyForm"

    componentRef = TrophyFormComponent

    constructor(
        name: string,
        public constextSettings: Map<string, IContextSetting|undefined>,
        public huntingDistricts: HuntingDistrict[],
        data?: Trophy
    ) {
        super(name, data)
    }

    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onSubmit: (() => void)|undefined = undefined
}

export class PoiTypeSettingForm extends Form {

    public static className = "PoiTypeSettingForm"
    public className = "PoiTypeSettingForm"

    public componentRef: Type<any> = SettingGeoObjectTypeFormComponent
    // no sub forms... 

    constructor(
        public name: string,
        public settingId: string,
        
        public data?: ConfigurationItem,
    ) {
        super(name, data)
    }
    
    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onSubmit: (() => void)|undefined = undefined
    onCreate: ((data: any) => void)|undefined = undefined
    onDelete: ((data) => void)|undefined = undefined

    onOpenIconPicker: ((data: any) => void)|undefined = undefined

}

export class SiteReferralSettingForm extends Form {

    public static className = "SiteReferralSettingForm"
    public className = "SiteReferralSettingForm"

    public componentRef: Type<any> = SettingSiteReferralComponent
    // no sub forms... 

    constructor(
        public name: string,
        public settingId: string,
        public existingValues: SiteReferralItem[],
        public data?: any,
    ) {
        super(name, data)
    }
    
    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onSubmit: (() => void)|undefined = undefined
    onDelete: ((data:any) => void)|undefined = undefined
    onCreate: ((data: any) => void)|undefined = undefined
}



export class gOLineTypesSettingForm extends Form {

    public static className = "geoObjectLineTypesSettingForm"
    public className = "geoObjectLineTypesSettingForm"

    public componentRef: Type<any> = GeoObjectLineTypesSettingFormComponent
    // no sub forms... 

    constructor(
        public name: string,
        public settingId: string,
        
        public data?: GeoObjLineTypesData,
    ) {
        super(name, data)
    }
    
    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onSubmit: (() => void)|undefined = undefined
    onDelete: ((data:any) => void)|undefined = undefined
    onCreate: ((data: any) => void)|undefined = undefined
}


export class gOPolygonTypesSettingForm extends Form {

    public static className = "geoObjectPolygonTypesSettingForm"
    public className = "geoObjectPolygonTypesSettingForm"

    public componentRef: Type<any> = GeoObjectPolygonTypesSettingFormComponent
    // no sub forms... 

    constructor(
        public name: string,
        public settingId: string,
        
        public data?: GeoObjPolygonTypesData,
    ) {
        super(name, data)
    }
    
    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onSubmit: (() => void)|undefined = undefined
    onDelete: ((data:any) => void)|undefined = undefined
    onCreate: ((data: any) => void)|undefined = undefined
}


export class gOCategorySettingForm extends Form {

    public static className = "geoObjectCategorySettingForm"
    public className = "geoObjectCategorySettingForm"

    public componentRef: Type<any> = GeoObjectCategoryFormComponent
    // no sub forms... 

    constructor(
        public name: string,
        public settingId: string,
        public data?: GeoObjCategoryData,
    ) {
        super(name, data)
    }
    
    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onSubmit: (() => void)|undefined = undefined
    onDelete: ((data:any) => void)|undefined = undefined
    onCreate: ((data: any) => void)|undefined = undefined
}

export class usRolesSettingForm extends Form {

    public static className = "userRolesSettingForm"
    public className = "userRolesSettingForm"

    public componentRef: Type<any> = UserRolesFormComponent
    // no sub forms... 

    constructor(
        public name: string,
        public settingId: string,
        public data?: userRolesData,
    ) {
        super(name, data)
    }
    
    onCancle() {
        this.listeners.forEach((obj: any) => {
            obj.onCancle(this)
        })
    }
    onSuccessfullySubmitted() {
        this.listeners.forEach((obj: any) => {
            obj.onSuccessfullySubmitted(this)
        })
    }

    onSubmit: (() => void)|undefined = undefined
    onDelete: ((data:any) => void)|undefined = undefined
    onCreate: ((data: any) => void)|undefined = undefined
}